var BaseService = require('./core/_BaseServiceV2');

function AnalyticsService() {
	BaseService.apply(this, arguments);
}

AnalyticsService.prototype = Object.create(BaseService.prototype);

AnalyticsService.create = function () {
	var service = new AnalyticsService('analytix');

	BaseService._init(service, 'analytix');

	return service;
};

module.exports = AnalyticsService.create();
